export default "__VITE_ASSET__DgVqQ2Ow__"